// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getProfileUsers, getAttendance } from "../data/repository";
import { format } from 'date-fns';

// Functional Component for Login Page
function DisplayAttendance(props) {
    // Declaration of useState Variables and Hook
    const [users, setUsersData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { date } = useParams(); // Extract date from URL
    const [search, setSearch] = useState('');
    const [attendanceData, setAttendanceData] = useState([]);
    const currentDate2 = format(new Date(date), 'MM/dd/yyyy');
    const [genderFilter, setGenderFilter] = useState(props.user.gender === "Male" ? "Atfal/Male" : props.user.gender === "Female" ? "Nasirat/Female" : "All");

    useEffect(() => {
        // Loads User Details from DB
        async function loadUserDetails() {
            const currentDetails = await getProfileUsers();
            setUsersData(currentDetails)
            setIsLoading(false);
        }

        const loadAttendanceData = async () => {
            const attendance = await getAttendance(currentDate2);
            setAttendanceData(attendance?.attendance || []);
        }

        // Calls the functions above
        loadUserDetails();
        loadAttendanceData();
    }, [currentDate2]);

    const handleSearch = async (event) => {
        setSearch(event.target.value.toLowerCase());
    }

    const findFatherName = (studentID) => {
        const userWithMatchingID = users.find(user => user.id === studentID);
        return userWithMatchingID ? userWithMatchingID.fathersName : "";
    };

    const findMotherName = (studentID) => {
        const userWithMatchingID = users.find(user => user.id === studentID);
        return userWithMatchingID ? userWithMatchingID.mothersName : "";
    };


    return (
        <div>
            <p>&nbsp;</p>
            <h3 className="text-center">View Attendance for {new Date(date).toLocaleDateString('en-GB')}:</h3>

            <br />
            <div className="searchCenter">
                <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input type="text" style={{ border: "1px solid #112c3f", borderRadius: "10rem" }} className="form-control" placeholder="Search" aria-label="Search" onChange={handleSearch} />
                </div>
            </div>

            {(props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male")) && (
                <div style={{ textAlign: "center", margin: "0.5rem" }}>
                    <select style={{ border: "1px solid #112c3f", borderRadius: "0.5rem", padding: "0.25rem 0.5rem" }} value={genderFilter} onChange={(e) => setGenderFilter(e.target.value)}>
                        <option value="All">All</option>
                        <option value="Atfal/Male">Atfal/Male</option>
                        <option value="Nasirat/Female">Nasirat/Female</option>
                    </select>
                    <div style={{ fontSize: "0.75rem", color: "#555", marginTop: "0.25rem" }}>
                        Gender
                    </div>
                </div>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
                <Link to="/ViewAttendanceDates">
                    <button type="button" style={{ margin: "5px" }} className="text-center btn btn-success">Go Back to View Attendance Records</button>
                </Link>
            </div>

            <div className="table-responsive">
                {isLoading ?
                    <div className="card-body text-center">
                        <span className="text-muted">Loading Students...</span>
                    </div>
                    :
                    <div>
                        <table className="table table-striped" style={{ margin: "0" }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th style={{ color: "#112c3f" }} scope="col">ID</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Name</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Parent</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Group</th>
                                    <th style={{ color: "#112c3f" }} scope="col">Gender</th>
                                    <th className="text-center" style={{ color: "#112c3f" }} scope="col">Attendance</th>
                                </tr>
                            </thead>
                            {/* Mapping Users state Variable to access its content easily to display in Table */}
                            {users.filter((userDetails) => {
                                return search.toLowerCase() === '' ? userDetails : (userDetails.name && userDetails.name.toLowerCase().includes(search)) || (userDetails.group && userDetails.group.toLowerCase().includes(search)) || (userDetails.id && userDetails.id.toLowerCase().includes(search)) || (userDetails.gender && userDetails.gender.toLowerCase().includes(search));
                            }).map((userDetails) => {
                                // Check if the student ID exists in the attendanceData array
                                const attendanceStudent = attendanceData.find(
                                    (student) => student.id === userDetails.id
                                );

                                // Get the status if the student exists in the attendanceData array
                                const status = attendanceStudent ? attendanceStudent.status : "";

                                return (
                                    <tbody key={userDetails.id}>
                                        {/* Dont display the name of the logged in user but the rest, And dont show Admin for teachers */}
                                        {(userDetails.group !== "Admin" ) &&
                                            <>
                                                {/* If logged in user is FemaleTeachers then Display only Nasirat List and If MaleTeahers are logged in show only Atfal list or if Admin is logged in show full list*/}
                                                {((props.user.group === "Female Teacher" && userDetails.gender === "Nasirat" && userDetails.archived !== true) ||
                                                    (props.user.group === "Male Teacher" && userDetails.gender === "Atfal" && userDetails.archived !== true) ||
                                                    (props.user.group === "Admin" && userDetails.archived !== true) ||
                                                    // (props.user.group === "Admin" && props.user.id === "MAAdminAcc") ||
                                                    (props.user.group === "Principal" && props.user.gender === "Female" && (userDetails.gender === "Nasirat" || userDetails.gender === "Female") && userDetails.archived !== true ) ||
                                                    // (props.user.group === "Principal" && props.user.gender === "Male" && (userDetails.gender === "Atfal" || userDetails.gender === "Male") && userDetails.archived !== true ) ||
                                                    (props.user.group === "Principal" && props.user.gender === "Male" && userDetails.archived !== true ) ||
                                                    (props.user.group === "Vice Principal" && props.user.gender === "Female" && (userDetails.gender === "Nasirat" || userDetails.gender === "Female") && userDetails.archived !== true ) ||
                                                    (props.user.group === "Vice Principal" && props.user.gender === "Male" && (userDetails.gender === "Atfal" || userDetails.gender === "Male") && userDetails.archived !== true ) ||
                                                    (props.user.group === "Admin Staff" && props.user.gender === "Female" && (userDetails.gender === "Nasirat" || userDetails.gender === "Female") && userDetails.archived !== true) ||
                                                    (props.user.group === "Admin Staff" && props.user.gender === "Male" && (userDetails.gender === "Atfal" || userDetails.gender === "Male") && userDetails.archived !== true)
                                                ) &&
                                                    ((props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male"))
                                                    ? (genderFilter === "All" || 
                                                        (genderFilter === "Atfal/Male" && (userDetails.gender === "Male" || userDetails.gender === "Atfal")) || 
                                                        (genderFilter === "Nasirat/Female" && (userDetails.gender === "Female" || userDetails.gender === "Nasirat"))
                                                    )
                                                    : true) &&
                                                    <tr>
                                                        <td></td>
                                                        <td style={{ color: "#112c3f" }}>{userDetails.id}</td>
                                                        <td style={{ color: "#112c3f" }}>{userDetails.name}</td>
                                                        <td style={{ color: "#112c3f" }}>
                                                            {userDetails.gender === "Female" || userDetails.gender === "Nasirat"
                                                                ? findMotherName(userDetails.id)
                                                                : findFatherName(userDetails.id)}
                                                        </td>
                                                        <td style={{ color: "#112c3f" }}>{userDetails.group}</td>
                                                        <td style={{ color: "#112c3f" }}>{userDetails.gender}</td>
                                                        <td style={{ color: "#112c3f" }}>
                                                            <div className="attendance-buttons">
                                                                <button className={`attendance-button ${status === "Present" ? "selected present" : "present"}`}>Present</button>
                                                                <button className={`attendance-button ${status === "Absent" ? "selected absent" : "absent"}`} >Absent</button>
                                                                <button className={`attendance-button ${status === "Approved Leave" ? "selected approved" : "approved"}`}>Approved Leave</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </>
                                        }
                                    </tbody>
                                )
                            })}
                        </table>
                    </div>
                }
            </div>
        </div>
    );
}

// Export the Attendance Function
export default DisplayAttendance;
